import type { MenuItem } from "~/models/MenuItem"
import { PERMISSIONS } from "./permissions"
const palette = 'palette'
const reviews = 'reviews'
const handyman = 'handyman'
const shoppingmode = 'shoppingmode'

export const profile_menu: MenuItem[] = [
    {
        title: "shoppingCard.my",
        icon: "credit_card",
        route: "/profile/shopping_card",
        color: "grey-9",
        can: (props) => props.auth.user != null,
    },
    {
        title: "orders.my",
        route: "/profile/orders",
        icon: "request_quote",
        color: "grey-9",
        can: (props) => props.auth.user != null,
    },
    {
        title: "fields.beneficiary",
        route: "/profile/beneficiaries",
        icon: "users",
        color: "grey-9",
        can: (props) => props.auth.user != null,
    },
    {
        title: "fields.favorites_products",
        route: "/profile/favorites",
        icon: "favorite",
        color: "grey-9",
        can: (props) => props.auth.user != null,
    }
    // {
    //     title: 'reservations.my',
    //     route: 'reservations.my',
    //     icon: 'book_online',
    //     color: 'grey-9',
    //     can: props => props.auth.user != null
    // },
]

export const navbar_menu: {
    route_name: string
    route_current: string
    show_condition: Function | null
    name: string
}[] = [
        {
            route_name: "store",
            route_current: "store",
            show_condition: null,
            name: "home.store",
        },
        {
            route_name: "store.services",
            route_current: "store.services",
            show_condition: () => false,
            name: "home.services",
        },
        {
            route_name: "blogs.index",
            route_current: "blogs.index",
            show_condition: null,
            name: "blog.title",
        },
        {
            route_name: "contact",
            route_current: "contact",
            show_condition: null,
            name: "home.contact_us",
        },
        {
            route_name: "about",
            route_current: "about",
            show_condition: (page: {
                props: { information: { enable_about_us: any } }
            }) => page.props.information.enable_about_us,
            name: "home.about_us",
        },
        {
            route_name: "frequent-asks",
            route_current: "frequent-asks",
            show_condition: (page: {
                props: { information: { enable_frequent_asks: any } }
            }) => page.props.information.enable_frequent_asks,
            name: "fields.faq",
        },
    ]

/**
 * Main menu
 *
 * @author Abel David.
 */
export const main_menu: MenuItem[] = [
    {
        title: "nav.manage_and_configuration",
        icon: "sym_o_manufacturing",
        color: "gray-9",
        breadCrumbRoute: true,
        children: [
            {
                title: "nav.manage",
                icon: "sym_o_work",
                color: "grey-9",
                breadCrumbRoute: true,
                children: [
                    {
                        title: "stores.managers.title",
                        route: "/admin/managers",
                        icon: "sym_o_person_pin",
                        color: "grey-9",
                        can: "read_managers",
                        environment: "store",
                    },
                    {
                        title: "products.title",
                        icon: "sym_o_local_mall",
                        color: "grey-9",
                        breadCrumbRoute: true,
                        children: [
                            {
                                title: "products.list",
                                route: "/admin/products",
                                icon: "sym_o_apparel",
                                color: "grey-9",
                                can: "read_products",
                                environment: "store",
                            },
                            {
                                title: "combos.list",
                                route: "/admin/combos",
                                icon: "sym_o_local_mall",
                                color: "grey-9",
                                environment: "marketplace",
                            },
                            // {
                            //     title: "categories.title",
                            //     route: "/admin/categories",
                            //     icon: "category",
                            //     color: "grey-9",
                            //     can: "read_categories",
                            //     environment: "store",
                            // },
                            {
                                title: "brands.title",
                                route: "/admin/brands",
                                icon: "sym_o_shoppingmode",
                                color: "grey-9",
                                environment: "store",
                                can: "read_brands",
                            },
                        ],
                    },
                    {
                        title: "sale.title",
                        icon: "sym_o_paid",
                        color: "grey-9",
                        children: [
                            {
                                title: "dispatchOrders.title",
                                route: "/admin/dispatch-orders",
                                icon: "sym_o_assignment",
                                color: "grey-9",
                                can: "read_dispatch_orders",
                                environment: "store",
                            },
                        ],
                    },
                    {
                        title: "offers.title",
                        route: "/admin/offers",
                        icon: "sym_o_redeem",
                        color: "grey-9",
                        can: PERMISSIONS.READ_OFFERS,
                        environment: "store",
                    },
                    {
                        title: "valoration.title",
                        color: "gray-9",
                        icon: "sym_o_comment_bank",
                        route: "/admin/criterias",
                        can: "criteria_and_answer",
                        environment: "store",
                    },
                    {
                        title: "products.validation_review",
                        color: "gray-9",
                        icon: 'sym_o_reviews',
                        route: "/admin/reviews",
                        can: "rating_products",
                        environment: "store",
                    },
                    {
                        title: "stores.balance.title",
                        route: "/admin/stores/balance",
                        icon: "sym_o_credit_card",
                        color: "grey-9",
                        can: PERMISSIONS.BALANCE,
                        environment: "store",
                    },
                ],
            },
            {
                title: "settings.title",
                icon: "sym_o_settings_account_box",
                color: "grey-9",
                children: [
                    {
                        title: "stores.settings.notifications.title",
                        route: "/admin/stores/settings/notifications",
                        icon: 'sym_o_handyman',
                        color: "grey-9",
                        can: PERMISSIONS.NOTIFICATIONS,
                        environment: "store",
                    },
                    {
                        title: "stores.settings.customization.title",
                        route: "/admin/stores/settings/customizations",
                        icon: 'sym_o_palette',
                        color: "grey-9",
                        can: PERMISSIONS.CUSTOMIZATIONS,
                        environment: "store",
                    },
                    {
                        title: "stores.settings.delivery.title",
                        route: "/admin/stores/settings/delivery",
                        icon: "sym_o_local_shipping",
                        color: "grey-9",
                        can: PERMISSIONS.DELIVERY,
                        environment: "store",
                    },
                ],
            },
        ],
    },
    {
        title: "nav.marketplace",
        icon: "sym_o_store",
        color: "gray-9",
        breadCrumbRoute: true,
        children: [
            {
                title: "nav.manage",
                icon: "sym_o_work",
                color: "grey-9",
                breadCrumbRoute: true,
                children: [
                    {
                        title: "stores.title",
                        route: "/admin/stores",
                        icon: "sym_o_storefront",
                        color: "grey-9",
                        can: "read_stores",
                        environment: "marketplace",
                    },
                    {
                        title: "withdraw_requests.title",
                        route: "/admin/withdraw-requests",
                        icon: "sym_o_request_quote",
                        color: "grey-9",
                        can: PERMISSIONS.READ_WITHDRAW_REQUESTS,
                        environment: "marketplace",
                    },
                    {
                        title: "users.title",
                        route: "/admin/users",
                        icon: "sym_o_group",
                        color: "grey-9",
                        can: "read_users",
                        environment: "marketplace",
                    },
                    {
                        title: "roles.title",
                        route: "/admin/roles",
                        icon: "sym_o_verified_user",
                        color: "grey-9",
                        can: "read_roles",
                        environment: "marketplace",
                    },
                    {
                        title: "products.title",
                        icon: "sym_o_local_mall",
                        color: "grey-9",
                        children: [
                            {
                                title: "products.list",
                                route: "/admin/products",
                                icon: "sym_o_apparel",
                                color: "grey-9",
                                can: "read_products",
                                environment: "marketplace",
                            },
                            {
                                title: "combos.list",
                                route: "/admin/combos",
                                icon: "sym_o_local_mall",
                                color: "grey-9",
                                environment: "marketplace",
                            },
                            {
                                title: "categories.title",
                                route: "/admin/categories",
                                icon: "sym_o_category",
                                color: "grey-9",
                                can: "read_categories",
                                environment: "marketplace",
                            },
                            {
                                title: "brands.title",
                                route: "/admin/brands",
                                icon: "sym_o_shoppingmode",
                                color: "grey-9",
                                environment: "marketplace",
                                can: "read_brands",
                            },
                        ],
                    },
                    {
                        title: "blog.title",
                        color: "grey-9",
                        icon: "sym_o_book_ribbon",
                        breadCrumbRoute: true,
                        children: [
                            {
                                route: "/admin/blogs/posts",
                                title: "post.title",
                                icon: "sym_o_book",
                                color: "grey-9",
                                can: "read_post",
                            },
                            {
                                route: "/admin/blogs/categories",
                                title: "blog_categories.title",
                                icon: "sym_o_list",
                                color: "grey-9",
                                can: "read_post",
                            },
                            {
                                route: "/admin/blogs/keywords",
                                title: "keywords.title",
                                icon: "sym_o_keyboard",
                                color: "grey-9",
                                can: "read_post",
                            },
                        ],
                    },

                    {
                        title: "sale.title",
                        icon: "sym_o_paid",
                        color: "grey-9",
                        breadCrumbRoute: true,
                        children: [
                            {
                                title: "invoices.title",
                                route: "/admin/invoices",
                                icon: "sym_o_receipt_long",
                                color: "grey-9",
                                can: "read_invoices",
                                environment: "marketplace",
                            },
                            {
                                title: "invoices.create",
                                route: "/admin/invoices/create",
                                icon: "sym_o_note_add",
                                color: "grey-9",
                                can: "read_invoices",
                                environment: "marketplace",
                            },
                            {
                                title: "orders.title",
                                route: "/admin/orders",
                                icon: "sym_o_local_shipping",
                                color: "grey-9",
                                can: "read_orders",
                                environment: "marketplace",
                            },
                        ],
                    },
                    {
                        title: "banners.title",
                        route: "/admin/banners",
                        icon: "sym_o_panorama",
                        color: "grey-9",
                        can: "read_banners",
                        environment: "marketplace",
                    },
                    {
                        title: "report.title",
                        icon: "sym_o_assignment",
                        color: "grey-9",
                        can: "read_reports",
                        environment: "marketplace",
                        breadCrumbRoute: true,
                        children: [
                            {
                                title: "report.for_sale",
                                route: "reports.sales",
                                icon: "sym_o_request_page",
                                can: "read_for_sale_reports",
                                color: "grey-9",
                            },
                            {
                                title: "report.for_inventary",
                                route: "reports.inventory",
                                icon: "sym_o_inventory",
                                color: "grey-9",
                                can: "read_for_inventary_reports",
                            },
                            {
                                title: "report.orders",
                                color: "grey-9",
                                icon: "sym_o_receipt",
                                route: "reports.orders",
                                can: "read_for_order_reports",
                            },
                            {
                                title: "report.movements",
                                color: "grey-9",
                                icon: "sym_o_warehouse",
                                route: "reports.movements",
                                can: "read_for_movement_reports",
                            },
                            {
                                title: "report.salesaccounting",
                                color: "grey-9",
                                icon: "sym_o_credit_card",
                                route: "reports.salesaccounting",
                                can: "read_for_sales_accounting_reports",
                            },
                            {
                                title: "report.sold_product",
                                color: "grey-9",
                                icon: "sym_o_add_shopping_cart",
                                route: "reports.soldProduct",
                                can: "read_for_sold_products",
                            },
                        ],
                    },
                    {
                        title: "products.validation_review",
                        color: "gray-9",
                        icon: "sym_o_comment_bank",
                        route: "/admin/reviews",
                        can: "rating_products",
                        environment: "marketplace",
                    },
                ],
            },
            {
                title: "settings.title",
                icon: "sym_o_settings_account_box",
                color: "grey-9",
                breadCrumbRoute: true,
                children: [
                    {
                        title: "settings.generals",
                        route: "/admin/settings/generals",
                        icon: 'sym_o_handyman',
                        color: "grey-9",
                        can: ["read_settings", "update_settings"],
                        environment: "marketplace",
                    },
                    {
                        title: "settings.customization",
                        route: "/admin/settings/customization",
                        icon: 'sym_o_palette',
                        color: "grey-9",
                        can: ["read_settings", "update_settings"],
                        environment: "marketplace",
                    },
                    {
                        title: "Monedas",
                        route: "coins.index",
                        icon: "sym_o_payments",
                        color: "grey-9",
                        can: "read_coins",
                        environment: "marketplace",
                    },
                    {
                        title: "Tasa de cambio",
                        route: "exchange_rates.get-per-day",
                        icon: "sym_o_currency_exchange",
                        color: "grey-9",
                        can: "read_exchange_rate",
                        environment: "marketplace",
                    },
                    {
                        title: "stripe-proxy.title",
                        color: "grey-9",
                        icon: "sym_o_credit_card",
                        environment: "marketplace",
                        children: [
                            {
                                title: "stripe-proxy.credentials",
                                color: "grey-9",
                                icon: "sym_o_credit_card",
                                route: "/admin/stripe-proxy/credentials",
                                can: PERMISSIONS.MANAGE_STRIPE_PROXY_SERVER_CREDENTIALS,
                            },
                            {
                                title: "stripe-proxy.transactions",
                                color: "grey-9",
                                icon: "sym_o_credit_card",
                                route: "/admin/stripe-proxy/transactions",
                                can: PERMISSIONS.READ_STRIPE_PROXY_SERVER_TRANSACTIONS,
                            },
                        ],
                    },
                    {
                        title: "b2bauth.clients",
                        color: "grey-9",
                        icon: "sym_o_group",
                        route: "/admin/b2bauth/clients",
                        can: PERMISSIONS.READ_B2B_AUTH_CLIENTS,
                        environment: "marketplace",
                    },
                ],
            },
            {
                title: "nav.analytics",
                icon: "sym_o_line_axis",
                color: "grey-9",
                breadCrumbRoute: true,
                children: [
                    {
                        title: "analytics.visits",
                        route: "analytics.visits",
                        icon: "sym_o_query_stats",
                        color: "grey-9",
                        can: "read_analytics",
                        environment: "marketplace",
                    },
                    {
                        title: "analytics.sales",
                        route: "analytics.sales",
                        icon: "sym_o_monitoring",
                        color: "grey-9",
                        can: "read_analytics",
                        environment: "marketplace",
                    },
                    {
                        title: "analytics.products",
                        route: "analytics.mostsold",
                        icon: "sym_o_insert_chart",
                        color: "grey-9",
                        can: "read_analytics",
                        environment: "marketplace",
                    },
                ],
            },
        ],
    },
]

export const adminMenu: MenuItem[] = [
    {
        title: "nav.manage",
        icon: "sym_o_work",
        color: "grey-9",
        breadCrumbRoute: true,
        children: [
            {
                title: "users.title",
                route: "/admin/users",
                icon: "sym_o_group",
                color: "grey-9",
                can: "read_users",
                environment: "marketplace",
            },
            {
                title: "roles.title",
                route: "/admin/roles",
                icon: "sym_o_verified_user",
                color: "grey-9",
                can: "read_roles",
                environment: "marketplace",
            },
            {
                title: "stores.title",
                route: "/admin/stores",
                icon: "sym_o_storefront",
                color: "grey-9",
                can: "read_stores",
                environment: "marketplace",
            },
            {
                title: "stores.managers.title",
                route: "/admin/managers",
                icon: "sym_o_person_pin",
                color: "grey-9",
                can: "read_managers",
                environment: "store",
            },
            {
                title: "products.title",
                icon: "sym_o_local_mall",
                color: "grey-9",
                children: [
                    {
                        title: "products.list",
                        route: "/admin/products",
                        icon: "sym_o_apparel",
                        color: "grey-9",
                        can: "read_products",
                        environment: "both",
                    },
                    {
                        title: "combos.list",
                        route: "/admin/combos",
                        icon: "sym_o_local_mall",
                        color: "grey-9",
                        environment: "marketplace",
                    },
                    {
                        title: "categories.title",
                        route: "/admin/categories",
                        icon: "sym_o_category",
                        color: "grey-9",
                        can: "read_categories",
                        environment: "marketplace",
                    },
                    {
                        title: "brands.title",
                        route: "/admin/brands",
                        icon: 'sym_o_shoppingmode',
                        color: "grey-9",
                        environment: "both",
                        can: "read_brands",
                    },
                ],
            },
            {
                title: "sale.title",
                icon: "sym_o_paid",
                color: "grey-9",
                breadCrumbRoute: true,
                children: [
                    {
                        title: "invoices.title",
                        route: "/admin/invoices",
                        icon: "sym_o_receipt_long",
                        color: "grey-9",
                        can: "read_invoices",
                        environment: "marketplace",
                    },
                    {
                        title: "invoices.create",
                        route: "/admin/invoices/create",
                        icon: "sym_o_note_add",
                        color: "grey-9",
                        can: "read_invoices",
                        environment: "marketplace",
                    },
                    {
                        title: "orders.title",
                        route: "/admin/orders",
                        icon: "sym_o_local_shipping",
                        color: "grey-9",
                        can: "read_orders",
                        environment: "marketplace",
                    },
                    {
                        title: "dispatchOrders.title",
                        route: "/admin/dispatch-orders",
                        icon: "sym_o_assignment",
                        color: "grey-9",
                        can: "read_dispatch_orders",
                        environment: "store",
                    },
                ],
            },
            {
                title: "banners.title",
                route: "/admin/banners",
                icon: "sym_o_panorama",
                color: "grey-9",
                can: "read_banners",
                environment: "marketplace",
            },
            {
                title: "offers.title",
                route: "/admin/offers",
                icon: "sym_o_redeem",
                color: "grey-9",
                can: PERMISSIONS.READ_OFFERS,
                environment: "store",
            },
            {
                title: "valoration.title",
                color: "gray-9",
                icon: "sym_o_comment_bank",
                route: "/admin/criterias",
                can: "criteria_and_answer",
                environment: "store",
            },
            {
                title: "products.validation_review",
                color: "gray-9",
                icon: "sym_o_reviews",
                route: "/admin/reviews",
                can: "rating_products",
                environment: "both",
            },
            {
                title: "stores.balance.title",
                route: "/admin/stores/balance",
                icon: "sym_o_credit_card",
                color: "grey-9",
                can: PERMISSIONS.BALANCE,
                environment: "store",
            },
            {
                title: "withdraw_requests.title",
                route: "/admin/withdraw-requests",
                icon: "sym_o_request_quote",
                color: "grey-9",
                can: PERMISSIONS.READ_WITHDRAW_REQUESTS,
                environment: "marketplace",
            },
            {
                title: "blog.title",
                color: "grey-9",
                icon: "sym_o_book_ribbon",
                breadCrumbRoute: true,
                environment: "marketplace",
                children: [
                    {
                        route: "/admin/blogs/posts",
                        title: "post.title",
                        icon: "sym_o_book",
                        color: "grey-9",
                        can: "read_post",
                    },
                    {
                        route: "/admin/blogs/categories",
                        title: "blog_categories.title",
                        icon: "sym_o_list",
                        color: "grey-9",
                        can: "read_post",
                    },
                    {
                        route: "/admin/blogs/keywords",
                        title: "keywords.title",
                        icon: "sym_o_keyboard",
                        color: "grey-9",
                        can: "read_post",
                    },
                ],
            },
        ],
    },
    {
        title: "settings.title",
        icon: "sym_o_settings_account_box",
        color: "grey-9",
        children: [
            {
                title: "stores.settings.notifications.title",
                route: "/admin/stores/settings/notifications",
                icon: "sym_o_handyman",
                color: "grey-9",
                can: PERMISSIONS.NOTIFICATIONS,
                environment: "store",
            },
            {
                title: "stores.settings.customization.title",
                route: "/admin/stores/settings/customizations",
                icon: "sym_o_palette",
                color: "grey-9",
                can: PERMISSIONS.CUSTOMIZATIONS,
                environment: "store",
            },
            {
                title: "stores.settings.delivery.title",
                route: "/admin/stores/settings/delivery",
                icon: "sym_o_local_shipping",
                color: "grey-9",
                can: PERMISSIONS.DELIVERY,
                environment: "store",
            },
            {
                title: "settings.generals",
                route: "/admin/settings/generals",
                icon: 'sym_o_handyman',
                color: "grey-9",
                can: ["read_settings", "update_settings"],
                environment: "marketplace",
            },
            {
                title: "settings.customization",
                route: "/admin/settings/customization",
                icon: "sym_o_palette",
                color: "grey-9",
                can: ["read_settings", "update_settings"],
                environment: "marketplace",
            },
            {
                title: "stripe-proxy.title",
                color: "grey-9",
                icon: "sym_o_credit_card",
                environment: "marketplace",
                children: [
                    {
                        title: "stripe-proxy.credentials",
                        color: "grey-9",
                        icon: "sym_o_credit_card",
                        route: "/admin/stripe-proxy/credentials",
                        can: PERMISSIONS.MANAGE_STRIPE_PROXY_SERVER_CREDENTIALS,
                    },
                    {
                        title: "stripe-proxy.transactions",
                        color: "grey-9",
                        icon: "sym_o_credit_card",
                        route: "/admin/stripe-proxy/transactions",
                        can: PERMISSIONS.READ_STRIPE_PROXY_SERVER_TRANSACTIONS,
                    },
                ],
            },
            {
                title: "b2bauth.clients",
                color: "grey-9",
                icon: "sym_o_group",
                route: "/admin/b2bauth/clients",
                can: PERMISSIONS.READ_B2B_AUTH_CLIENTS,
                environment: "marketplace",
            },
        ],
    },
    {
        title: "nav.analytics",
        icon: "sym_o_line_axis",
        color: "grey-9",
        breadCrumbRoute: true,
        children: [
            {
                title: "analytics.visits",
                route: "analytics.visits",
                icon: "sym_o_query_stats",
                color: "grey-9",
                can: "read_analytics",
                environment: "marketplace",
            },
            {
                title: "analytics.sales",
                route: "analytics.sales",
                icon: "sym_o_monitoring",
                color: "grey-9",
                can: "read_analytics",
                environment: "marketplace",
            },
            {
                title: "analytics.products",
                route: "analytics.mostsold",
                icon: "sym_o_insert_chart",
                color: "grey-9",
                can: "read_analytics",
                environment: "marketplace",
            },
        ],
    },
]
